import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { type BuiltInColorMap, isValidColor } from '../../utils';

export type ColorTileProps = {
	builtInColorMap: BuiltInColorMap;
	size?: string;
	testId?: string;
	value: string;
};

const colorTileStyles = xcss({
	border: `${token('border.width')} solid ${token('color.border')}`,
	borderRadius: token('radius.small'),
});

export const ColorTile = ({ builtInColorMap, value, size = '24', testId }: ColorTileProps) => {
	value = isValidColor(value)
		? builtInColorMap.getResponsiveColor(value)
		: token('elevation.surface.overlay');

	size = `${size}px`;
	return (
		<Box
			testId={testId ?? 'color-tile'}
			xcss={colorTileStyles}
			style={{ backgroundColor: value, height: size, width: size }}
		/>
	);
};
